import { MenuItem } from 'wilshire-ui/layout';

export const MENU_GROUPS: MenuItem[] = [
  {
    displayName: 'Users',
    routerLink: '/users',
    show: true,
    permissions: []
  },
  {
    displayName: 'Systems',
    routerLink: '/systems',
    show: true,
    permissions: []
  }
];
